import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from '@/pages/HomePage';
import { CalendarPage } from '@/pages/CalendarPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { AdminEventsPage } from '@/pages/admin/AdminEventsPage';
import { AdminEventEditPage } from '@/pages/admin/AdminEventEditPage';
import { AdminAuditPage } from '@/pages/admin/AdminAuditPage';
import { AdminCrawlersPage } from '@/pages/admin/AdminCrawlersPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/admin" element={<AdminEventsPage />} />
        <Route path="/admin/events/new" element={<AdminEventEditPage />} />
        <Route path="/admin/events/:id" element={<AdminEventEditPage />} />
        <Route path="/admin/crawlers" element={<AdminCrawlersPage />} />
        <Route path="/admin/audit" element={<AdminAuditPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
